import React, { useEffect, useState } from 'react';

import { requestInform as request } from 'api/user';
import Detail from 'components/pages/haccp/standardInfo/employee/Detail';
import Valid from 'components/pages/Valid';
import { getLoginInform } from 'function/login';
import { getErrorMessage } from 'function/message';
import { useConfirmModalState } from 'global/confirmModalState';
import useObjReducer from 'hooks/useObjReducer';
import { RESPONSE_CODE } from 'types/const';

/**
 * 마이 페이지
 */
const MyPage = () => {
  /* variable */
  const { seq } = getLoginInform();

  /* recoil */
  const { setConfirmModal } = useConfirmModalState();

  /* state */
  // 사용자 정보
  const [inform, setInform] = useObjReducer({});
  // 패스워드 재확인 여부
  const [isValid, setIsValid] = useState(false);

  /* watch */
  useEffect(() => {
    requestInform();
  }, []);

  /* method */
  // 사용자 정보 조회 요청
  const requestInform = async () => {
    try {
      const { data = {}, code, message } = await request(seq);

      if (code !== RESPONSE_CODE.Success) {
        throw {
          code,
          error: message
        };
      }

      setInform(data);
    } catch (error) {
      setConfirmModal({
        isOpen: true,
        message: getErrorMessage(error?.code, error?.error)
      });
    }
  };

  return (
    <>
      {isValid ? (
        <Detail />
      ) : (
        <Valid userId={inform.userId} onValid={() => setIsValid(true)} />
      )}
    </>
  );
};

export default MyPage;
